<template>
  <div>
    <v-card class="pa-5" color="transparent" flat>
      <v-card class="d-flex" flat color="transparent">
        <span class="heading-2 mx-5"> <b> Add new Team Member </b></span>
      </v-card>
      <v-card color="transparent" flat class="px-5 pt-5">
        <v-text-field
          class="email-text-area pt-1"
          hide-details
          single-line
          outlined
          label="Email Address"
          append-icon="mdi-email-outline"
          dense
          v-model="$v.Email.$model"
        ></v-text-field>
        <div class="red--text" v-if="$v.Email.$error">Email is required</div>
      </v-card>

      <v-card color="transparent" flat class="px-5 pt-5">
        <v-select
          :items="items"
          label="Role"
          dense
          item-text="Name"
          item-value="Id"
          class="email-text-area pt-1"
          hide-details
          single-line
          outlined
          background-color="#f6f8fc"
          v-model="Role"
        >
        </v-select>
      </v-card>

      <v-card color="transparent" flat class="px-5 pt-5">
        <p class="mb-0"><b>Message</b></p>
        <v-textarea
          name="input-7-1"
          class="mt-4"
          hide-details
          filled
          auto-grow
          v-model="$v.Message.$model"
          value="Has recibido una invitación para ser parte de IBA BODY TALK, lorem ipsum dolor sit amet consectetur adropising lorem ipsum dolor sit amet consectetur adropising."
        ></v-textarea>
        <div class="red--text" v-if="$v.Message.$error">
          Message is required
        </div>
      </v-card>

      <v-card-actions class="mx-5 mt-4">
        <v-row class="AddTeamFotterBtnDestop">
          <v-col cols="12" md="4">
            <v-btn
              color="grey lighten-1"
              text
              @click="close()"
              style="text-transform: none"
            >
              Cancel
            </v-btn>
          </v-col>
          <v-col cols="12" md="8">
            <v-btn
              depressed
              block
              color="primary"
              @click="send()"
              style="text-transform: none"
            >
              <span v-if="btnloader != true"> Send Invitation </span>
              <v-progress-circular
                indeterminate
                v-else
                size="20"
                class="px-5"
                color="white"
                v-show="btnloader"
              ></v-progress-circular>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="AddTeamFotterBtnMobile">
          <v-col cols="12" md="4">
            <v-btn
              depressed
              block
              color="primary"
              @click="send()"
              style="text-transform: none"
            >
              <span v-if="btnloader != true"> Send Invitation </span>
              <v-progress-circular
                indeterminate
                v-else
                size="20"
                class="px-5"
                color="white"
                v-show="btnloader"
              ></v-progress-circular>
            </v-btn>
          </v-col>
          <v-col cols="12" md="8">
            <v-btn
              color="grey lighten-1"
              text
              block
              @click="close()"
              style="text-transform: none"
            >
              Cancel
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
export default {
  name: "addteamcomponent",
  props: ["add_dialog"],
  mixins: [validationMixin],
  computed: {
    ...mapGetters(["GetRoles"]),
  },
  data() {
    return {
      items: ["Foo", "Bar", "Fizz", "Buzz"],
      Role: null,
      Message: "",
      Email: "",
      btnloader: false,
    };
  },
  validations: {
    Message: {
      required,
    },
    Email: {
      required,
      email,
    },
  },
  mounted() {
    this.fetchData();
  },

  methods: {
    close() {
      this.$emit("close");
    },
    update() {
      this.$emit("update");
    },
    send() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        // console.log("error");
      } else {
        this.btnloader = true;
        var obj = {
          Email: this.Email,
          Message: this.Message,
          RoleId: this.Role,
        };

        this.$store.dispatch("RegisterTeamMember", obj).then((res) => {
          if (res.Status) {
            this.add_dialog = false;
            this.btnloader = false;
            this.snackbar = true;
            this.update();
          } else {
            this.$swal.fire({
              icon: "warning",
              title: `<span style="font-size:20px">${res.Message}</span>`,
              confirmButtonColor: "#3085d6",
              showConfirmButton: true,
            });
            this.btnloader = false;
          }
        });
      }
    },
    fetchData() {
      var obj = {
        page: 1,
        pageSize: "All",
      };
      this.$store.dispatch("GetRoles", obj).then(() => {
        this.Role = this.GetRoles[0].Id;
        this.items = this.GetRoles;
      });
    },
  },
};
</script>

<style scoped>
.email-text-area {
  background: #f6f8fc;
}
.AddTeamFotterBtnMobile {
  display: none;
}

@media screen and (max-width: 430px) {
  .AddTeamFotterBtnMobile {
    display: block;
  }
  .AddTeamFotterBtnDestop {
    display: none;
  }
}
</style>
